import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/contexts/AppContext";
import AppLayout from "@/components/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import ImportData from "@/pages/ImportData";
import ForecastEngine from "@/pages/ForecastEngine";
import InventoryRisk from "@/pages/InventoryRisk";
import SupplierInsights from "@/pages/SupplierInsights";
import SkuRationalization from "@/pages/SkuRationalization";
import Settings from "@/pages/Settings";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/import" element={<ImportData />} />
            <Route path="/forecast" element={<ForecastEngine />} />
            <Route path="/risk" element={<InventoryRisk />} />
            <Route path="/suppliers" element={<SupplierInsights />} />
            <Route path="/rationalization" element={<SkuRationalization />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AppProvider>
  );
}

export default App;
